import React from 'react';

const Resume = () => {
  const handlePrint = () => window.print();

  return (
    <div className="min-h-screen bg-white py-12">
      <div className="max-w-3xl mx-auto bg-white p-8 shadow">
        <header className="flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-bold">Aoife Lynch</h1>
            <p className="text-sm text-gray-600">UX/UI & Frontend Developer — Dublin, Ireland</p>
          </div>
          <div>
            <button onClick={handlePrint} className="btn btn-sm bg-gradient-to-r from-accent.green to-brand.DEFAULT text-white">Print / Download</button>
          </div>
        </header>

        <section className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <h2 className="text-xl font-semibold">Profile</h2>
            <p className="text-gray-700">Creative Computing student with experience in React, Tailwind, and product design. Seeking UX/UI and frontend roles. Resume details to be filled.</p>

            <h3 className="mt-4 font-semibold">Experience</h3>
            <ul className="list-disc list-inside text-gray-700">
              <li>Frontend Development — React & Tailwind</li>
              <li>UX Research & Prototyping — Figma</li>
            </ul>
          </div>

          <aside>
            <h3 className="font-semibold">Contact</h3>
            <p className="text-gray-700">aoifellynch@outlook.com</p>
            <h3 className="mt-4 font-semibold">Skills</h3>
            <p className="text-gray-700">React, JavaScript, Tailwind, Figma, HTML, CSS</p>
          </aside>
        </section>
      </div>
    </div>
  );
};

export default Resume;
